import SpriteSymbol from "../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SolidPinLine",
  "use": "SolidPinLine-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"SolidPinLine\"><path d=\"M12.617 4.076a1 1 0 011.09.217l6 6A1 1 0 0119 12h-1.65L13 15.48V18a1 1 0 01-1.707.707L9 16.414l-3.293 3.293a1 1 0 01-1.414-1.414L7.586 15l-2.293-2.293A1 1 0 016 11h2.52L12 6.65V5a1 1 0 01.617-.924zm1.32 3.275a1 1 0 01-.156.274l-4 5A1 1 0 019 13h-.586L11 15.586V15a1 1 0 01.375-.78l5-4a1 1 0 01.274-.156L13.936 7.35z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol